import FactorDetails from "./FactorDetails";

export default FactorDetails;
